module.exports = __webpack_public_path__ + "static/media/train6.34107cc0.png";